import { useEffect, useState } from 'react';

import { Divider, Group, Text } from '@mantine/core';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from '../../../shared/components/UI/Button/Button';

import * as Filters from './Filters';
import { Permission } from '../../../shared/entities/Access';
import { usePermission } from '../../../shared/hooks/usePermission.hook';
import { useWorkspaceUsersQuery } from '../../../shared/hooks/useWorkspaceUsersQuery.hook';
import { CreateWorkspaceUserModal } from './CreateWorkspaceUserModal';

export function WorkspaceSettingsHeader() {
  const { t } = useTranslation('workspaceSettings');
  const { hasPermission } = usePermission();
  const navigate = useNavigate();

  const { data: workspaceUsers } = useWorkspaceUsersQuery();

  const [isModalOpened, setIsModalOpened] = useState(false);

  useEffect(() => {
    if (!hasPermission(Permission.CREATE_USER)) {
      navigate('/');
    }
  }, [hasPermission, navigate]);

  return (
    <Group
      noWrap
      bg="white"
      p="03"
      position="apart"
      sx={theme => ({ borderTop: `1px solid ${theme.colors.gray[1]}` })}
    >
      <Group noWrap spacing="02">
        <Group noWrap spacing="00">
          <Text variant="sm" fw={500}>
            {workspaceUsers?.length}
          </Text>
          <Text variant="sm" fw={400} c="gray.9">
            {t('workspaceUserTable.users')}
          </Text>
        </Group>
        <Divider orientation="vertical" h="04" my="auto" />
        <Filters.RoleSelect />
      </Group>
      <Group noWrap spacing="04">
        <Filters.SearchInput />
        <Button onClick={() => setIsModalOpened(true)}>
          {t('workspaceUserTable.addUser')}
        </Button>
        <CreateWorkspaceUserModal
          opened={isModalOpened}
          onClose={() => setIsModalOpened(false)}
        />
      </Group>
    </Group>
  );
}
